import styled from 'styled-components'
import { IconButton, tokens } from '@arvoreeducacao/bonsai-ds'
import { Link as Lk } from 'react-router-dom'

export const Container = styled.div`
  border-bottom: solid 1px ${tokens.colors.black2};
  display: flex;
  flex-direction: row;
  height: 48px;
  align-items: center;
  padding: 0 ${tokens.spacing.spacing_12}px;
`

export const Link = styled(Lk)`
  text-decoration: none;
`

export const StyledIconButton = styled(IconButton)`
  height: 32px;
  border: 0 none;
  margin-right: 8px;
  color: ${tokens.colors.black5};

  &:last-child {
    margin-right: 0;
  }

  > span {
    margin-right: ${tokens.spacing.spacingXSmall}px;
  }

  &:hover {
    border: 0 none;
    color: ${tokens.colors.black5};
    background-color: ${tokens.colors.black1};
  }
`
